import {getMessaging, getToken} from "firebase/messaging";
import {initializeApp} from "firebase/app";
import {firebaseConfig, vapidKey} from "app/config/firebaseConfig";

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const requestPermission = async (): Promise<string | null> => {

  const permission = await Notification.requestPermission();
  if (permission === "granted") {

    try {
      const currentToken = await getToken(messaging, {vapidKey: vapidKey});
      if (currentToken) {
        return currentToken;
      } else {
        return null;
      }
    } catch (err) {
      return null;
    }
  } else {
    return null;
  }
};
